/**
 * Fuel consumption unit values
 */
export enum FuelConsumptionUnitEnum {
	LKM = 'lkm',
	MPG = 'mpg',
}
